<template>
  <div>
    <BodyLoader :loading="firstLoad"></BodyLoader>
    <div class="dvModals">
      <div id="modal-send-print" class="modal">
        <div class="dvModalHeader">
          <div class="dvModalHeader-title">
            Send Email
          </div>
          <a class="modal-close waves-effect waves-dark btn-Close flexCenterAll" href="javascript:void(0)"><span class="icon-action_cancel"></span></a>
        </div><!--dvModalHeader-->

        <div class="dvModalContent">
          <form>
            <div class="row">
              <div class="col s12 l12 dvModalContent-field">
                <label class="defaultModal-label">Email Address</label>
                <input v-model="printSendTo" class="browser-default defaultModal-input" placeholder="e.g. juan.delacruz@ayalaland-intl.com" type="text" />
                <div class="defaultModal-helper-text">
                  * Required
                </div>
                <div class="defaultModal-helper-text">
                  Multiple email addresses should be , separated. For ex: j@email.com, m@email.com
                </div>
              </div>
            </div>
          </form>
        </div><!--dvModalContent-->
        <div class="dvModalFooter">
          <a
            v-if="!sendingPrint"
            @click="sendlPrint()"
            href="javascript:void(0)" class="waves-effect waves-light btn btn-Tools btnSubmit flexCenterAll">
            <span class="icon-action_check"></span>Send
          </a>

          <a
            v-if="sendingPrint"
            href="javascript:void(0)"
            :class="{ disabled: true }"
            class="waves-effect waves-light btn btn-Tools btnSubmit flexCenterAll">
            Sending...
          </a>

          <a
            :disabled="sendingPrint"
            @click="closeModal('modal-send-print')"
            href="javascript:void(0)" class="waves-effect waves-light btn btn-Tools btnCancel flexCenterAll"><span class="icon-action_cancel"></span>Cancel</a>
        </div>
      </div><!-- modal-->
    </div>

    <div class="row dvQuickGlance">




      <div class="col s12 l7 valign-wrapper dvQuickGlance-main">
        <div class="col s12 dvQuickGlance-info valign-wrapper">
          <ImageUploader></ImageUploader>
          <div class="dvQuickGlance-user">
            <div class="dvQuickGlance-user-welcome" v-if="$store.getters.getFirstName.length > 0">Welcome, <strong>{{ $store.getters.getFirstName }}</strong>!</div>
            <div class="dvQuickGlance-user-welcome" v-if="$store.getters.getFirstName.length == 0">Welcome!</div>
            <div class="dvQuickGlance-user-team">{{ channel.name }} - {{ team.name }}</div>
            <div class="dvQuickGlance-user-position">{{ userDetails.position }}</div>
          </div> <!-- dvQuickGlance-user -->
        </div> <!-- dvQuickGlance-info -->
        <div class="col s12 dvQuickGlance-action">
          <router-link
            class="waves-effect waves-light btn btn-Action flexCenterAll"
            :to="{ name:'referrals_add_new' }">
            <span class="icon-action_add_circle"></span><div>Add Client</div>
          </router-link>
        </div> <!-- dvQuickGlance-action -->
      </div> <!-- dvQuickGlance-main -->

      <div class="col s12 l5 dvQuickGlance-links">
        <router-link
          :to="{ name: 'referral_status', params: { status: 'valid' } }"
          class="waves-effect waves-light dvQuickGlance-link">
          <div class="dvQuickGlance-link-label">Valid<span class="icon-nav_link_right"></span></div>
          <div class="dvQuickGlance-link-count bgValid flexCenterAll">{{ referralSummary.valid }}</div>
        </router-link> <!-- dvQuickGlance-link -->
        <router-link
          :to="{ name:'referral_status', params: { status: 'pending'} }"
          class="waves-effect waves-light dvQuickGlance-link">
          <div class="dvQuickGlance-link-label">Pending<span class="icon-nav_link_right"></span></div>
          <div class="dvQuickGlance-link-count bgPending flexCenterAll">{{ referralSummary.pending }}</div>
        </router-link> <!-- dvQuickGlance-link -->
        <router-link
          :to="{ name:'referral_status', params: { status: 'expiring'} }"
          class="waves-effect waves-light dvQuickGlance-link">
          <div class="dvQuickGlance-link-label">Expiring<span class="icon-nav_link_right"></span></div>
          <div class="dvQuickGlance-link-count bgExpiring flexCenterAll">{{ referralSummary.expiring }}</div>
        </router-link> <!-- dvQuickGlance-link -->
      </div>
    </div> <!-- dvQuickGlance -->

    <div class="row dvContent">
      <div class="col s12 l7 dvContentMain">
        <div class="dvSectionTitle "><span class="icon-fs_referrals"></span>Latest Referrals</div>

        <div
          v-if="referrals.length == 0"
          class="dvBlankSection">
          <div class="dvBlankSectionBox flexCenterAll">
            <div class="dvBlankSection-content">
              <div class="dvBlankSection-icon flexCenterAll"><i class="material-icons">find_in_page</i></div>
              <div class="dvBlankSection-text-primary center-align">
                There are no active referrals to display
              </div>
            </div>
          </div>
        </div>

        <CardView
          v-for="(referral, index) in referrals" :key="index"
          :referral="referral"
          :idx="index"
          @extendReferral="extendReferral"
          @confirm="confirm">
        </CardView>












      </div> <!-- dvContentMain -->

      <div class="col s12 l5 dvContentSide">
        <div class="dvSectionTitle"><span class="icon-fs_world"></span>Global Stats</div>

        <div class="dvStats">


          <div class="dvCardStats dvCardStats-minHeight">
            <div class="dvLoader-container-overlay  animate_loaderOut groupRefLoader">
              <div class="dvLoader-bar">
                <v-progress-linear
                  indeterminate
                  background-color="#757575"
                  color="#18FFFF"
                  height="5"
                  absolute
                  top
                ></v-progress-linear>
              </div>

              <div class="dvLoader-circular-sm animate_loader fadeIn">
                <v-progress-circular
                  :size="40"
                  :width="3"
                  color="#CCCCCC"
                  indeterminate
                ></v-progress-circular>
              </div>
            </div> <!-- dvLoader-container-overlay-->

            <div class="dvCardStats-header">
              <div class="dvCardStats-info">
                <span class="icon-fs_referrals"></span>
                <div class="dvCardStats-title">
                  <div class="dvCardStats-subtitle">{{ team.name }}</div>
                  <span>Total Group Referral</span>
                </div> <!-- dvCardStats-title -->
              </div> <!-- dvCardStats-info -->
              <!-- <a href="#" class="waves-effect waves-light btn-Pill isStat">
                <div class="label">May 2019</div>
                <span class="icon-nav_chevron-down hide-on-small-only"></span>
              </a> -->
              <div class="dvCardStats-filter">
                <v-select
                  v-model="selectedgroupReferralFilterDate"
                  @change="filterGlobalStats('groupReferral')"
                  :items="dateFilters"
                  :menu-props="{contentClass: 'statsFilter'}"
                  :label="selectedgroupReferralFilterDateLabel"
                   item-text="name"
                   return-object
                   dense
                   solo
                >
                  <template
                    slot="item"
                    slot-scope="data"
                  >
                    <!-- Divider and Header-->
                    <template v-if="typeof data.item !== 'object'">
                      <v-list-tile-content v-text="data.item"/>
                    </template>
                    <!-- Items -->
                    <template v-else>
                      <v-list-tile-content>
                        <v-list-tile-title v-html="data.item.name"/>
                      </v-list-tile-content>
                    </template>
                  </template>
                </v-select>

              </div>
            </div> <!-- dvCardStats-header -->


            <div class="dvCardStats-content isPodium" v-if="globalStats.total_group_referrals.referrals_stats.length ==0 && !groupRefLoader">No record found</div>
            <div class="dvCardStats-content" v-if="globalStats.total_group_referrals.referrals_stats.length !=0 && !groupRefLoader">
              <div class="centeredVert widthFilled">
                <div class="numLarge" id="referralValue">
                  <ICountUp
                  :delay="1000"
                  :endVal="endVal"
                  :options="options"
                  />
                </div>

                <div class="dvCardStats-graph">
                  <v-sparkline
                      :value="globalStats.total_group_referrals.referrals_stats"
                      :gradient="['#00BCD4','#8BC34A']"
                      :smooth="20"
                      :padding="5"
                      :line-width="4"
                      :fill="false"
                      type="trend"
                      gradient-direction="left"
                      stroke-linecap="round"
                      auto-draw
                    ></v-sparkline>

                </div> <!-- dvCardStats-graph -->


                <a href="#" class="dvCardStats-content-zoom hide"><span class="icon-action_add_circle"></span></a>
              </div>
            </div> <!-- dvCardStats-content -->

            <div class="dvCardStats-content-divider"></div>

            <div class="dvCardStats-header"  v-if="globalStats.total_group_referrals.referrals_stats.length !=0 && !groupRefLoader">
              <div class="dvCardStats-info">
                <span class="icon-fs_target"></span>
                <div class="dvCardStats-title">
                  <span>Target Group Referral</span>
                </div> <!-- dvCardStats-title -->
              </div> <!-- dvCardStats-info -->
            </div> <!-- dvCardStats-header -->

            <div class="dvCardStats-content" v-if="globalStats.total_group_referrals.team_target_referrals > 0">
              <div class="dvData-hline">
                <div class="dvData-hline-data" :style="'width:'+ globalStats.total_group_referrals.total_referrals_percentage +'%;'"></div>
              </div>

              <div class="widthFilled">
                <div class="numSmall">{{ globalStats.total_group_referrals.total_referrals }} / {{ globalStats.total_group_referrals.team_target_referrals }}</div>
                <div class="numSmall colSecondary">{{ globalStats.total_group_referrals.total_referrals_percentage }}%</div>
              </div>
            </div> <!-- dvCardStats-content -->

            <div class="dvCardStats-content" v-if="globalStats.total_group_referrals.referrals_stats.length !=0 && globalStats.total_group_referrals.team_target_referrals == 0">
              <div class="dvData-hline">
                <div class="dvData-hline-data" style="width:100%;"></div>
              </div>
            </div> <!-- dvCardStats-content -->

          </div> <!-- dvCardStats -->



          <div class="dvCardStats dvCardStats-minHeight">
            <div class="dvLoader-container-overlay  animate_loaderOut cityRefLoader">
              <div class="dvLoader-bar">
                <v-progress-linear
                  indeterminate
                  background-color="#757575"
                  color="#18FFFF"
                  height="5"
                  absolute
                  top
                ></v-progress-linear>
              </div>

              <div class="dvLoader-circular-sm animate_loader fadeIn">
                <v-progress-circular
                  :size="40"
                  :width="3"
                  color="#CCCCCC"
                  indeterminate
                ></v-progress-circular>
              </div>
            </div> <!-- dvLoader-container-overlay-->

            <div class="dvCardStats-header">
              <div class="dvCardStats-info">
                <span class="icon-content_location"></span>
                <div class="dvCardStats-title">
                  <span>Top Cities for Referrals</span>
                </div> <!-- dvCardStats-title -->
              </div> <!-- dvCardStats-info -->
              <div class="dvCardStats-filter">
                <v-select
                  v-model="selectedCityFilterDate"
                  @change="filterGlobalStats('cities')"
                  :items="dateFilters"
                  :menu-props="{contentClass: 'statsFilter'}"
                  :label="selectedCityFilterDateLabel"
                   item-text="name"
                   return-object
                   dense
                   solo
                >
                  <template
                    slot="item"
                    slot-scope="data"
                  >
                    <!-- Divider and Header-->
                    <template v-if="typeof data.item !== 'object'">
                      <v-list-tile-content v-text="data.item"/>
                    </template>
                    <!-- Items -->
                    <template v-else>
                      <v-list-tile-content>
                        <v-list-tile-title v-html="data.item.name"/>
                      </v-list-tile-content>
                    </template>
                  </template>
                </v-select>

              </div>

              <!-- <a href="#" class="waves-effect waves-light btn-Pill isStat">
                <div class="label">May 2019</div>
                <span class="icon-nav_chevron-down hide-on-small-only"></span>
              </a> -->
            </div> <!-- dvCardStats-header -->


            <div class="dvCardStats-content isPodium">
              <span v-if="globalStats.top_cities.length ==0">No record found</span>
              <div v-if="globalStats.top_cities[0]">
                <div class="dvCardStats-content-podium">
                  <div class="numBullet">1</div>
                  <div class="">{{ globalStats.top_cities[0].city }}</div>
                  <div class="numMed">{{ globalStats.top_cities[0].total }}</div>
                </div>
              </div>
              <div v-if="globalStats.top_cities[1]" class="dvCardStats-podium-divider"></div>

              <div v-if="globalStats.top_cities[1]">
                <div class="dvCardStats-content-podium">
                  <div class="numBullet">2</div>
                  <div class="">{{ globalStats.top_cities[1].city }}</div>
                  <div class="numMed">{{ globalStats.top_cities[1].total }}</div>
                </div>
              </div>
              <div v-if="globalStats.top_cities[2]" class="dvCardStats-podium-divider"></div>

              <div v-if="globalStats.top_cities[2]">
                <div class="dvCardStats-content-podium">
                  <div class="numBullet">3</div>
                  <div class="">{{ globalStats.top_cities[2].city }}</div>
                  <div class="numMed">{{ globalStats.top_cities[2].total }}</div>
                </div>
              </div>
            </div> <!-- dvCardStats-content -->

          </div> <!-- dvCardStats -->



          <div class="dvCardStats dvCardStats-minHeight">
            <div class="dvLoader-container-overlay  animate_loaderOut projInqLoader">
              <div class="dvLoader-bar">
                <v-progress-linear
                  indeterminate
                  background-color="#757575"
                  color="#18FFFF"
                  height="5"
                  absolute
                  top
                ></v-progress-linear>
              </div>

              <div class="dvLoader-circular-sm animate_loader fadeIn">
                <v-progress-circular
                  :size="40"
                  :width="3"
                  color="#CCCCCC"
                  indeterminate
                ></v-progress-circular>
              </div>
            </div> <!-- dvLoader-container-overlay-->

            <div class="dvCardStats-header">
              <div class="dvCardStats-info">
                <span class="icon-content_project"></span>
                <div class="dvCardStats-title">
                  <span>Top Properties<br />for Inquiries</span>
                </div> <!-- dvCardStats-title -->
              </div> <!-- dvCardStats-info -->

              <div class="dvCardStats-filter">
                <v-select
                  v-model="selectedInqFilterDate"
                  @change="filterGlobalStats('projectInq')"
                  :items="dateFilters"
                  :menu-props="{contentClass: 'statsFilter'}"
                  :label="selectedInqFilterDateLabel"
                   item-text="name"
                   return-object
                   dense
                   solo
                >
                  <template
                    slot="item"
                    slot-scope="data"
                  >
                    <!-- Divider and Header-->
                    <template v-if="typeof data.item !== 'object'">
                      <v-list-tile-content v-text="data.item"/>
                    </template>
                    <!-- Items -->
                    <template v-else>
                      <v-list-tile-content>
                        <v-list-tile-title v-html="data.item.name"/>
                      </v-list-tile-content>
                    </template>
                  </template>
                </v-select>

              </div>

               <!-- dvCardStats-filter -->

              <!-- <a href="#" class="waves-effect waves-light btn-Pill isStat">
                <div class="label">May 2019</div>
                <span class="icon-nav_chevron-down hide-on-small-only"></span>
              </a> -->
            </div> <!-- dvCardStats-header -->

            <div class="dvCardStats-content isPodium" v-if="globalStats.top_project_inquiries.length ==0">No record found</div>
            <div class="dvCardStats-content isList">
              <div
                v-for="(top_project_inquiry, index) in globalStats.top_project_inquiries" :key="index"
                class="centeredVert widthFilled">
                <div class="numBullet">{{ index + 1 }}</div>
                <div class="">{{ top_project_inquiry.name }}</div>
                <div class="fxLineHorz"></div>
                <div class="numSmall">{{ top_project_inquiry.total }}</div>
              </div>
            </div> <!-- dvCardStats-content -->

          </div> <!-- dvCardStats -->


        </div>
      </div> <!-- dvContentSide -->

      <div class="col s12 dvContentTools">
        <div class="dvContentTools-fx"></div>
        <div class="dvContentTools-content">
          <a
            v-if="!loading"
            href="javascript:void(0)"
            :class="{ disabled: !pager.hasNext || loading }"
            @click="nextPage()"
            class="waves-effect waves-light btn btn-Tools flexCenterAll">
            Load more<span class="icon-nav_chevron-down"></span>
          </a>

          <a
            v-if="loading"
            href="javascript:void(0)"
            :class="{ disabled: true }"
            class="waves-effect waves-light btn btn-Tools flexCenterAll">
            Please wait...
          </a>

          <router-link class="waves-effect waves-light btn btn-Tools flexCenterAll" :to="{ name:'referrals' }">
            View all referrals
          </router-link>
        </div> <!-- dvContentTools-content -->
        <div class="dvContentTools-page">
          <a @click="emailPrint('modal-send-print')" href="javascript:void(0)" class="waves-effect waves-dark btn btn-Tools isSecondary flexCenterAll"><span class="icon-content_email"></span><div class="hide-on-small-only">Email</div></a>
          <a @click="printJS()" href="javascript:void(0)" class="waves-effect waves-dark btn btn-Tools isSecondary flexCenterAll"><span class="icon-action_print"></span><div class="hide-on-small-only">Print</div></a>
          <ToTop></ToTop>
        </div> <!-- dvContentTools-page -->
      </div> <!-- dvContentTools -->

    </div> <!-- dvContent -->

    <SnackBar :snackbarDetails="snackbarDetails"></SnackBar>
    <ConfirmationDialog
      :dialog="dialog"
      @doConfirm="doConfirm"
      @doCancel="doCancel">
    </ConfirmationDialog>
  </div>
</template>

<script>
  import CardView from '@/components/referral_view/ClientCardView.vue'
  import SnackBar from '@/components/snackbar/SnackBar.vue'
  import ConfirmationDialog from '@/components/confirmation_view/ConfirmationDialog.vue'
  import ImageUploader from '@/components/ImageUploader.vue'
  import BodyLoader from '@/components/BodyLoader.vue'
  import ICountUp from 'vue-countup-v2'
  import printJS from 'print-js'
  import M from 'materialize-css'
  import ToTop from '@/components/totop/ToTop.vue'
  // import TopCityBlock from './TopCityBlock.vue'

  export default {
    name: 'dashboard-main',
    data: () => ({
      printSendTo: '',
      sendingPrint: false,
      ageGroupLoader: false,
      projInqLoader: false,
      cityRefLoader: false,
      groupRefLoader: false,
      dateFilters: [],
      selectedgroupReferralFilterDate: {},
      selectedgroupReferralFilterDateLabel: '',
      selectedAgeGroupFilterDate: {},
      selectedAgeGroupFilterDateLabel: '',
      selectedInqFilterDate: {},
      selectedInqFilterDateLabel: '',
      selectedCityFilterDate: {},
      selectedCityFilterDateLabel: '',
      stats_cityReferral_filter:[],
      cityReferral_filter: [],
      user_image: '',
      total_group_referrals: [],
      globalStats: {
        total_group_referrals: {
          referrals_stats: []
        },
        top_cities: [],
        top_project_inquiries: [],
        top_referral_age_group: []
      },
      dialog: {
        show: false,
        title: '',
        body: '',
        action: '',
        id: ''
      },
      snackbarDetails: {
        color: 'sb-success',
        msg: '',
        show: false
      },
      loading: false,
      extending: false,
      team: {},
      channel: {},
      userDetails: {},
      referrals: [],
      referralSummary: {
        pending: '',
        valid: '',
        expiring: ''
      },
      pager: {
        currentPage: 1,
        perPage: 5,
        hasNext: 0
      },
      firstLoad: true,
      loadedCnt: 0,
      endVal: 0,
      settings: {},
      hasSettings: false,
      domain: '',
      options: {
          useEasing: true,
          useGrouping: true,
          separator: ',',
          decimal: '.',
          prefix: '',
          suffix: ''
        }
    }),
    computed: {
      refreshImport  (){
        return this.$store.getters.getRefreshPage();
      }
    },
    watch: {
      refreshImport (newPage, oldPage) {
        let allowedPages = [ 'dashboard' ]
        let res = newPage.split(':');
        if(allowedPages.indexOf(res[0]) >= 0){
          this.pager.currentPage = 1
          this.referrals = []
          this.getLatestReferrals()
          this.getGlobalStats()
        }
      },
      loadedCnt: function() {
        // let self = this
        if(this.loadedCnt == 2){
          this.firstLoad = false
        }
      },
      ageGroupLoader: function() {
        let self = this
        if(this.ageGroupLoader){
          self.$jQuery(".ageGroupLoader").show();
        }else{
          self.$jQuery(".ageGroupLoader").fadeOut();
        }
      },
      projInqLoader: function() {
        let self = this
        if(this.projInqLoader){
          self.$jQuery(".projInqLoader").show();
        }else{
          self.$jQuery(".projInqLoader").fadeOut();
        }
      },
      cityRefLoader: function() {
        let self = this
        if(this.cityRefLoader){
          self.$jQuery(".cityRefLoader").show();
        }else{
          self.$jQuery(".cityRefLoader").fadeOut();
        }
      },
      groupRefLoader: function() {
        let self = this
        if(this.groupRefLoader){
          self.$jQuery(".groupRefLoader").show();
        }else{
          self.$jQuery(".groupRefLoader").fadeOut();
        }
      }
    },
    methods: {
      printJS (){
        printJS(this.domain+'/api/referrals?request_type=print');
      },
      closeModal (str){
        const elem = document.getElementById(str);
        const instance = M.Modal.init(elem, {dismissible: false});
        instance.close();

        this.printSendTo = ''
      },
      emailPrint (str){
        const elem = document.getElementById(str);
        const instance = M.Modal.init(elem, {dismissible: false});
        instance.open();
      },
      sendlPrint (){
        if(this.printSendTo == ''){
          this.showMessage('The email field is required.', 'sb-failed')
          return false
        }

        if(this.sendingPrint){
          return false
        }

        let self = this
        self.sendingPrint = true

        let url = '/api/referrals?request_type=mail&send_to='+this.printSendTo
        this.$http.plain.get(url)
          .then(response => {
            if(response.data == 'sent'){
              this.showMessage('Email has been sent', 'sb-success')
            }
            this.printSendTo = ''
            this.closeModal('modal-send-print')
          })
          .catch(error => {
            if (error.response.status === 500) {
              this.showMessage("Something went wrong! Please try again.", 'sb-failed')
            }else{
              this.showMessage(error.response.data.messages.error, 'sb-failed')
            }
          })
          .then(function () {
            self.sendingPrint = false
          })
      },
      onReady: function(instance, CountUp) {
        const that = this;
        instance.update(that.endVal + 100);
      },
      hasContact: function(referral){
        return this.displayContactNos(referral) == '' ? false : true
      },
      displayContactNos: function(referral){
        let mobTels = [];
        if(referral.mobile_no.length > 0){
          mobTels.push('<a href="tel:'+referral.mobile_no+'">'+referral.mobile_no+'</a>')
        }
        if(referral.phone_no.length > 0){
          mobTels.push('<a href="tel:'+referral.phone_no+'">'+referral.phone_no+'</a>')
        }

        return mobTels.join(', ')
      },
      showMessage(msg, color){
        this.snackbarDetails = {
          color: color,
          msg: msg,
          show: true
        }
      },
      nextPage(){
        this.pager.currentPage++;
        this.getLatestReferrals();
      },
      confirm (action){
        document.querySelectorAll('.tippy-popper').forEach(popper => {
          popper._tippy.hide()
        })

        if(action.type == 'archive'){
          this.dialog = {
            show: true,
            title: 'Are you sure you want to archive '+action.client+'?',
            body: 'You can\'t undo this action.',
            icon: 'icon-action_archive',
            positionBtn: 'Archive',
            negativeBtn: 'Cancel',
            actionType: action.type,
            id: action.id
          }
        }else if(action.type== 'extend-referral'){
          this.dialog = {
            show: true,
            title: 'Do you want to extend referral?',
            body: 'You have '+action.available_extended+' extension/s left',
            icon: 'icon-action_refresh',
            positionBtn: 'Extend',
            negativeBtn: 'Cancel',
            actionType: action.type,
            id: action.id
          }
        }else if(action.type == 'verify-referral'){
          this.dialog = {
            show: true,
            title: 'Please verify the data imported from the old CRS',
            body: '',
            icon: 'icon-action_check_circle',
            positionBtn: 'Verify',
            negativeBtn: 'Cancel',
            negativeBtnWithAction: true,
            actionType: action.type,
            id: action.id
          }
        }
      },
      doCancel (){
        if(this.dialog.actionType == 'verify-referral'){
          this.$router.push({ name: 'referrals_update_client', params: { id: this.dialog.id } })
        }
      },
      doConfirm (){
        this.dialog.show = false
        if(this.dialog.actionType == 'archive'){
          this.processArchive(this.dialog.id)
        }else if(this.dialog.actionType == 'extend-referral'){
          this.extendReferral(this.dialog.id)
        }else if(this.dialog.actionType == 'verify-referral'){
          this.$router.push({ name: 'referrals_client_view', params: { id: this.dialog.id }, query: { verified: 'yes' } })
        }
      },
      processArchive (id) {
        if(this.archiving){
          return false;
        }
        this.archiving = true
        let self = this

        this.$http.secured.post('api/referrals/archive/'+ id)
          .then(response => {
            window.scrollTo(0, 0)

            this.referrals = []
            this.pager.currentPage = 1
            this.getLatestReferrals()
            this.getGlobalStats()
            this.showMessage(response.data.message, 'sb-success')
          })
          .catch(error => {
            this.showMessage(error, 'sb-failed')
          })
          .then(function () {
            self.archiving = false
          })
      },
      extendReferral (id){
        this.processExtendReferrals(id)
      },
      processExtendReferrals (ids){
        if(this.extending){
          return false;
        }

        this.extending = true
        let self = this

        this.$http.secured.post('api/referrals/extend/'+ ids)
          .then(response => {

            window.scrollTo(0, 0)

            this.referrals = []
            this.pager.currentPage = 1
            this.getLatestReferrals()
            this.showMessage(response.data.message, 'sb-success')
          })
          .catch(error => {
            if (error.response) {
              this.showMessage(error.response.data.messages.error, 'sb-failed')
            }else{
              this.showMessage("Something went wrong! Please try again.", 'sb-failed')
            }
          })
          .then(function () {
            self.extending = false
          })
      },
      getLatestReferrals () {
        if(this.loading){
          return false;
        }
        let self = this
        this.loading = true
        this.$http.plain.get('api/referrals?page='+this.pager.currentPage+'&per_page='+this.pager.perPage)
          .then(response => {

            let referrals = response.data.referrals;
            this.referralSummary = response.data.referral_summary
            this.pager.hasNext = response.data.pager.has_next_page

            for (let i = 0; i < referrals.length; i++){
              this.referrals.push(referrals[i])
            }
            // document.getElementById("toFocus").focus();
          })
          .catch(error => {
            if (error.response) {
              this.showMessage(error.response.data.messages.error, 'sb-failed')
            }else{
              this.showMessage("Something went wrong! Please try again.", 'sb-failed')
            }
          })
          .then(function () {
            self.loading = false
            self.loadedCnt++
          })
        },
        saveSettings (){
          this.$store.commit('setUserSettings', { data: this.settings })
          let settings = this.settings

          this.$http.secured.post('api/users/save-settings', settings)
            .then(response => {
              console.log(response.data)
            })
        },
        filterGlobalStats (globalStatType){

          let url = 'api/global-stats/';
          let selectedData = {}
          if(globalStatType == 'cities'){
            url += 'top-cities';
            selectedData = this.selectedCityFilterDate
            this.cityRefLoader = true
            this.settings.city = selectedData
          }else if(globalStatType == 'projectInq'){
            url += 'top-property-inquiries';
            selectedData = this.selectedInqFilterDate
            this.projInqLoader = true
            this.settings.profInq = selectedData
          }else if(globalStatType == 'ageGroup'){
            url += 'top-referral-age-groups';
            selectedData = this.selectedAgeGroupFilterDate
            this.ageGroupLoader = true
            this.globalStats.top_referral_age_group.top_age_group_percentage = 0
            this.globalStats.top_referral_age_group.top_age_group = ''
            this.settings.ageGroup = selectedData
          }else if(globalStatType == 'groupReferral'){
            url += 'total-group-referrals';
            selectedData = this.selectedgroupReferralFilterDate
            this.groupRefLoader = true
            this.globalStats.total_group_referrals.referrals_stats = []
            this.settings.groupRef = selectedData
          }

          this.saveSettings()

          if(selectedData.type == 'monthly'){
            url += '?filter_type='+selectedData.type+'&month='+selectedData.month+'&year='+selectedData.year;
          }else if(selectedData.type == 'yearly'){
            url += '?filter_type='+selectedData.type+'&year='+selectedData.year;
          }else if(selectedData.type == 'all'){
            url += '?filter_type=all';
          }

          let self = this

          this.$http.plain.get(url)
            .then(response => {
              if(globalStatType == 'cities'){
                this.globalStats.top_cities = response.data
              }else if(globalStatType == 'projectInq'){
                this.globalStats.top_project_inquiries = response.data
              }else if(globalStatType == 'ageGroup'){
                this.globalStats.top_referral_age_group = response.data
              }else if(globalStatType == 'groupReferral'){
                self.globalStats.total_group_referrals = response.data
                self.endVal = self.globalStats.total_group_referrals.total_referrals
              }

              // this.globalStats = response.data
            })
            .catch(error => {
              if (error.response) {
                this.showMessage(error.response.data.messages.error, 'sb-failed')
              }else{
                this.showMessage("Something went wrong! Please try again.", 'sb-failed')
              }
            }).then(function () {
              if(globalStatType == 'cities'){
                self.cityRefLoader = false
              }else if(globalStatType == 'projectInq'){
                self.projInqLoader = false
              }else if(globalStatType == 'ageGroup'){
                self.ageGroupLoader = false
              }else if(globalStatType == 'groupReferral'){
                self.groupRefLoader = false
              }
            })
        },
        filterGlobalStatsCity (){
          let url = 'api/global-stats/';
          let selectedData = this.selectedCityFilterDate
          url += 'top-cities';

          if(selectedData.type == 'monthly'){
            url += '?filter_type='+selectedData.type+'&month='+selectedData.month+'&year='+selectedData.year;
          }else if(selectedData.type == 'yearly'){
            url += '?filter_type='+selectedData.type+'&year='+selectedData.year;
          }else if(selectedData.type == 'all'){
            url += '?filter_type=all';
          }

          let self = this
          // let self = this
          this.$http.plain.get(url)
            .then(response => {
              this.globalStats.top_cities = response.data
            })
            .catch(error => {
              if (error.response) {
                this.showMessage(error.response.data.messages.error, 'sb-failed')
              }else{
                this.showMessage("Something went wrong! Please try again.", 'sb-failed')
              }
            }).then(function () {
              self.loadedCnt++
            })
        },
        filterGlobalStatsGroupRef (){
          let url = 'api/global-stats/';
          let selectedData = this.selectedgroupReferralFilterDate
          url += 'total-group-referrals';

          if(selectedData.type == 'monthly'){
            url += '?filter_type='+selectedData.type+'&month='+selectedData.month+'&year='+selectedData.year;
          }else if(selectedData.type == 'yearly'){
            url += '?filter_type='+selectedData.type+'&year='+selectedData.year;
          }else if(selectedData.type == 'all'){
            url += '?filter_type=all';
          }

          let self = this
          // let self = this
          this.$http.plain.get(url)
            .then(response => {
              self.globalStats.total_group_referrals = response.data
              self.endVal = self.globalStats.total_group_referrals.total_referrals
            })
            .catch(error => {
              if (error.response) {
                this.showMessage(error.response.data.messages.error, 'sb-failed')
              }else{
                this.showMessage("Something went wrong! Please try again.", 'sb-failed')
              }
            }).then(function () {
              self.loadedCnt++
            })
        },
        filterGlobalStatsProfInq (){
          let url = 'api/global-stats/';
          let selectedData = this.selectedInqFilterDate
          url += 'top-property-inquiries';

          if(selectedData.type == 'monthly'){
            url += '?filter_type='+selectedData.type+'&month='+selectedData.month+'&year='+selectedData.year;
          }else if(selectedData.type == 'yearly'){
            url += '?filter_type='+selectedData.type+'&year='+selectedData.year;
          }else if(selectedData.type == 'all'){
            url += '?filter_type=all';
          }

          let self = this
          // let self = this
          this.$http.plain.get(url)
            .then(response => {
              this.globalStats.top_project_inquiries = response.data
            })
            .catch(error => {
              if (error.response) {
                this.showMessage(error.response.data.messages.error, 'sb-failed')
              }else{
                this.showMessage("Something went wrong! Please try again.", 'sb-failed')
              }
            }).then(function () {
              self.loadedCnt++
            })
        },
        filterGlobalStatsAgeGroup (){
          let url = 'api/global-stats/';
          let selectedData = this.selectedAgeGroupFilterDate
          url += 'top-referral-age-groups';

          if(selectedData.type == 'monthly'){
            url += '?filter_type='+selectedData.type+'&month='+selectedData.month+'&year='+selectedData.year;
          }else if(selectedData.type == 'yearly'){
            url += '?filter_type='+selectedData.type+'&year='+selectedData.year;
          }else if(selectedData.type == 'all'){
            url += '?filter_type=all';
          }

          let self = this
          // let self = this
          this.$http.plain.get(url)
            .then(response => {
              this.globalStats.top_referral_age_group = response.data
            })
            .catch(error => {
              if (error.response) {
                this.showMessage(error.response.data.messages.error, 'sb-failed')
              }else{
                this.showMessage("Something went wrong! Please try again.", 'sb-failed')
              }
            }).then(function () {
              self.loadedCnt++
            })
        },
        getGlobalStats () {
          let currentMonth = this.$moment().format('MM')
          let year = this.$moment().format('YYYY')
          let self = this
          // let globalStat = [];

          this.$http.plain.get('api/global-stats?filter_type=monthly&month='+currentMonth+'&year='+year)
            .then(response => {

              this.globalStats.top_cities = response.data.top_cities
              this.selectedCityFilterDateLabel = response.data.cityLabel

              this.selectedgroupReferralFilterDateLabel = response.data.groupRefLabel
              self.globalStats.total_group_referrals.referrals_stats = [0]
              setTimeout(function(){
                self.globalStats.total_group_referrals = response.data.total_group_referrals
                self.endVal = self.globalStats.total_group_referrals.total_referrals
              }, 500);

              this.globalStats.top_project_inquiries = response.data.top_project_inquiries
              this.selectedInqFilterDateLabel = response.data.profInqLabel

              this.globalStats.top_referral_age_group = response.data.top_referral_age_group
              this.selectedAgeGroupFilterDateLabel = response.data.ageGroupLabel

              this.dateFilters = response.data.stat_filters

            })
            .catch(error => {
              if (error.response) {
                this.showMessage(error.response.data.messages.error, 'sb-failed')
              }else{
                this.showMessage("Something went wrong! Please try again.", 'sb-failed')
              }
            })
            .then(function () {
              self.loadedCnt++
            })
          }
    },
    mounted() {

      if(this.$store.getters.getCurrentUserRole == this.$getConstRole('ROLE_SUB_ADMIN')){
        window.location.href = '/admin/channels'
      }

      this.$jQuery(".ageGroupLoader").hide();
      this.$jQuery(".projInqLoader").hide();
      this.$jQuery(".cityRefLoader").hide();
      this.$jQuery(".groupRefLoader").hide();
      this.settings = this.$store.getters.getCurrentUserDetails.settings

      if(this.settings && this.settings.length == 0){
        this.settings = {}
      }
      this.domain = this.$store.getters.getApiURL
      this.team = this.$store.getters.getTeam
      this.channel = this.$store.getters.getChannel
      this.userDetails = this.$store.getters.getCurrentUserDetails
      this.getLatestReferrals()
      this.getGlobalStats()
    },
    components: {
      CardView,
      SnackBar,
      ConfirmationDialog,
      ImageUploader,
      BodyLoader,
      ICountUp,
      ToTop
      // TopCityBlock
    }
  }
</script>
